<template>
  <div
    class="gs-preview-overlay"
    style="z-index: 1000005; display: flex; justify-content: center; align-items: center; background: rgba(0, 0, 0, 0.5)"
    @click.stop="close">
    <div
      style="
        background: #ffffff;
        padding: 24px 32px 32px;
        border-radius: 16px;
        width: 620px;
        max-width: 95vw;
        color: #1e293b;
        position: relative;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
      "
      @click.stop>
      <i
        class="el-icon-close"
        style="position: absolute; top: 24px; right: 24px; font-size: 16px; cursor: pointer; color: #64748b; font-weight: bold"
        @click="close"></i>

      <!-- Title -->
      <div style="text-align: left; margin-bottom: 16px">
        <div style="font-size: 18px; font-weight: 700; color: #1e293b; margin-bottom: 6px">Check Answer</div>
        <div style="color: #64748b; font-size: 12px; line-height: 1.4">
          <template v-if="isStuck">
            Student is stuck on this question. Review the details below to provide guidance.
          </template>
          <template v-else>
            Student’s answer was marked as wrong. Revalidate the student’s answer comparing it with the System provided correct answer.
          </template>
        </div>
      </div>

      <!-- Level (CPA Questions Only) -->
      <div v-if="isCpaQuestion">
        <div style="font-size: 13px; font-weight: 700; color: #475569; margin-bottom: 8px">Level {{ displayLevel }}: {{ displayBloomVerb }}</div>
        <!-- Question Box -->
        <div
          style="
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
            padding: 12px 16px;
            margin-bottom: 20px;
            font-size: 13px;
            color: #334155;
            max-height: 80px;
            overflow-y: auto;
          "
          v-html="questionText"></div>
      </div>

      <!-- Answers Comparison Grid (Only for wrong answers, NOT for stuck cases) -->
      <div v-if="!isStuck" style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px">
        <!-- Student Answer -->
        <div>
          <div style="font-size: 12px; font-weight: 700; color: #475569; margin-bottom: 6px">Student’s Answer</div>
          <div
            style="
              background: #f8fafc;
              border: 1px solid #e2e8f0;
              border-radius: 10px;
              padding: 14px;
              min-height: 100px;
              max-height: 160px;
              overflow-y: auto;
              font-size: 13px;
              color: #1e293b;
            "
            v-html="studentAnswerText || 'No answer submitted'"></div>
        </div>

        <!-- Correct Answer -->
        <div>
          <div style="font-size: 12px; font-weight: 700; color: #475569; margin-bottom: 6px">Correct Answer</div>
          <div
            style="
              background: #f0fdf4;
              border: 1px solid #bbf7d0;
              border-radius: 10px;
              padding: 14px;
              min-height: 100px;
              max-height: 160px;
              overflow-y: auto;
              font-size: 13px;
              color: #166534;
            "
            v-html="correctAnswerText || 'Correct answer unavailable'"></div>
        </div>
      </div>

      <!-- Info Banner (Only for wrong answers, NOT for stuck cases) -->
      <div
        v-if="!isStuck"
        style="
          display: flex;
          align-items: flex-start;
          gap: 10px;
          background: #eff6ff;
          border-radius: 8px;
          padding: 10px 14px;
          margin-bottom: 24px;
          font-size: 11px;
          color: #1e40af;
          line-height: 1.4;
        ">
        <i class="fa fa-info-circle" style="font-size: 14px; color: #3b82f6; margin-top: 2px"></i>
        <div>
          System marked this answer as wrong comparing with the correct answer provided by the teacher. If you still think that this answer provided by the
          student is correct, please mark it correct manually
        </div>
      </div>

      <!-- Action Buttons -->
      <div style="display: flex; gap: 16px" :style="{ marginTop: isStuck ? '24px' : '0' }">
        <button
          style="
            flex: 1;
            padding: 12px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            color: #0f172a;
            font-weight: 700;
            font-size: 14px;
            border-radius: 24px;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#f8fafc'"
          onmouseout="this.style.background='#ffffff'"
          @click="onHelpStudent">
          Help Student
        </button>
        <button
          v-if="!isStuck"
          style="
            flex: 1.4;
            padding: 12px;
            background: #10b981;
            border: 1px solid #10b981;
            color: #ffffff;
            font-weight: 700;
            font-size: 14px;
            border-radius: 24px;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#059669'"
          onmouseout="this.style.background='#10b981'"
          @click="onMarkCorrect">
          Mark Student’s Answer as Correct
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeacherCheckAnswerPopup',
  props: {
    log: {type: Object, default: () => ({})},
    slide: {type: Object, default: () => ({})},
  },
  computed: {
    isStuck() {
      if (!this.log) return false
      return (
        this.log.isStuck === true ||
        (typeof this.log.studentAnswer === 'string' && this.log.studentAnswer.includes('is stuck')) ||
        (typeof this.log.text === 'string' && this.log.text.includes('is stuck')) ||
        (typeof this.log.content === 'string' && this.log.content.includes('is stuck'))
      )
    },
    isCpaQuestion() {
      return Array.isArray(this.slide?.bloom) && this.slide.bloom.length && this.slide.cpa?.outcome?.length
    },
    displayLevel() {
      const bloom = this.slide && this.slide.bloom
      if (Array.isArray(bloom) && bloom.length > 0) return bloom[0] + 1
      return '2'
    },
    displayBloomVerb() {
      const verbs = {
        1: 'Remember',
        2: 'Understand',
        3: 'Apply',
        4: 'Analyze',
        5: 'Evaluate',
        6: 'Create',
      }
      return verbs[this.displayLevel] || 'Understand'
    },
    questionText() {
      if (!this.slide?.abstract?.data) return ''
      return this.slide.abstract.data
    },
    studentAnswerText() {
      if (!this.log) return ''
      let raw = this.log.studentAnswer || this.log.user_answer || this.log.content || this.log.text || ''
      if (raw.includes('OCR Text:')) {
        raw = raw.split('OCR Text:')[1]?.trim() || raw
      }
      return raw
    },
    correctAnswerText() {
      if (!this.slide?.abstract?.answer) return ''
      return this.slide.abstract.answer
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onHelpStudent() {
      this.$emit('help-student')
    },
    onMarkCorrect() {
      this.$emit('mark-correct')
    },
  },
}
</script>
